// FLAGS: none
// Chrome-free shell for the /login route. Renders an Outlet and nothing else — deliberately no auth check,
// because /login is the one route in routes.tsx that is not wrapped by the login gate.
import { Outlet } from "react-router";

const LoginLayout = () => {
  return <Outlet />;
};

export default LoginLayout;
